(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('EmployeeSelectionDialogCtrl', EmployeeSelectionDialogCtrl);

    function EmployeeSelectionDialogCtrl(close, $timeout, dialogOptions, lodash) {
        const vm = this;
        vm.options = dialogOptions.options;
        vm.employee = dialogOptions.employee;

        vm.selected = dialogOptions.employee || [];
        vm.is_selected = dialogOptions.is_selected;
        vm.dismiss = function () {
            close(false);
        };

        vm.confirm = function () {
            if (!!vm.employee) {
                close({
                    selected: vm.selected
                });
            } else {
                close(true);
            }
        };

        $timeout(function () {
            vm.show = true;
        });
    }
})();